module.exports = __webpack_public_path__ + "img/placeholder_img.1dc3922a.svg";